import { useId } from 'react';
import { cn } from '../../lib/utils';

/** The lizard eye: a reptilian almond, a deep Bedrock-green iris, and a vertical
 * slit pupil. Unique gradient ids per instance so multiple marks on a page don't
 * collide. */
export function Mark({ size = 28, className }: { size?: number; className?: string }) {
  const id = useId().replace(/:/g, '');
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="Lizrd"
    >
      <defs>
        <radialGradient id={`iris-${id}`} cx="50%" cy="42%" r="62%">
          <stop offset="0%" stopColor="#5bd199" />
          <stop offset="42%" stopColor="#1f8a5c" />
          <stop offset="100%" stopColor="#0c3d28" />
        </radialGradient>
        <clipPath id={`clip-${id}`}>
          <circle cx="32" cy="32" r="15.5" />
        </clipPath>
      </defs>
      <path
        d="M3 32 C 18 9, 46 9, 61 32 C 46 55, 18 55, 3 32 Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="text-border-strong"
      />
      <circle cx="32" cy="32" r="15.5" fill={`url(#iris-${id})`} />
      <g clipPath={`url(#clip-${id})`}>
        <ellipse cx="32" cy="32" rx="3.4" ry="15.5" fill="#08110e" />
      </g>
      <circle cx="26" cy="25" r="2.6" fill="#eafff4" opacity="0.85" />
    </svg>
  );
}

/** Mark + wordmark lockup. The R carries the brand green. */
export function Logo({ size = 26, className }: { size?: number; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <Mark size={size} />
      <span className="font-display text-lg font-extrabold tracking-tight text-bone">
        LIZ<span className="text-iris">R</span>D
      </span>
    </span>
  );
}
